<template>
    <section class="free-measurement-new">
        <div class="container">
            <div class="free-measurement-new__block">
                <div class="free-measurement-new__title">Бесплатный замер</div>
                <div class="free-measurement-new__subtitle">
                    Выезжаем на замер уже на следующий день после заявки
                </div>
                <div class="free-measurement-new__text">
                    Мастер приедет с большим количеством образцов тканей и
                    изделий, среди которых можно выбрать наиболее понравившееся
                </div>
                <div class="free-measurement-new__button">
                    <button
                        class="btn _primary free-measurement-new__btn"
                        @click="openForm"
                    >
                        Оформить заявку на замер
                    </button>
                </div>
            </div>
        </div>
        <div class="free-measurement-new__img">
            <img
                class="free-measurement-new__img_top"
                src="/assets/img/free-measurement/IMG_55711.png"
            />
            <img
                class="free-measurement-new__img_bottom"
                src="/assets/img/roller/free-car.png"
            />
        </div>
    </section>
</template>

<script>
import freeOrderForm from './modals/free-order-form';

export default {
    name: 'freeMeasurementNew',
    components: { freeOrderForm },
    methods: {
        openForm() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setFreeOrderFormStatus', true);
            document.body.classList.add('_no-scroll');
        },
    },
};
</script>

<style scoped></style>
